import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getCustomTagList } from '@/api/customTag'

export const useTagsStore = defineStore('tags', () => {
  // 标签列表
  const tagsList = ref([])

  // 获取标签数据（使用新标签 API）
  const getTagsData = async () => {
    try {
      const res = await getCustomTagList({ page: 1, pageSize: 10000 })
      tagsList.value = res.data.list || []
      return tagsList.value
    } catch (error) {
      console.error('获取标签列表失败:', error)
      tagsList.value = []
      return []
    }
  }

  // 根据ID获取标签名称（支持新旧两种格式）
  const getTagNameById = (tagId) => {
    // 尝试用 tag_id 匹配（新标签系统）
    let tag = tagsList.value.find(t => String(t.tag_id) === String(tagId))
    if (tag) return tag.tag_name

    // 尝试用 id 匹配（旧标签系统，向后兼容）
    tag = tagsList.value.find(t => String(t.id) === String(tagId))
    if (tag) return tag.tag_remark || tag.tag_name

    // 都找不到，返回标签ID
    return `标签ID: ${tagId}`
  }

  // 根据ID数组获取标签名称数组
  const getTagNamesByIds = (tagIds) => {
    if (!Array.isArray(tagIds)) return []
    return tagIds.map(id => getTagNameById(id))
  }

  return {
    tagsList,
    getTagsData,
    getTagNameById,
    getTagNamesByIds
  }
})